import React from "react";

const GlazedDonut = () => {
  return (
    <div className="blogWhat-content">
      <h5>3. Glazed Donut Nails: A Soft & Glossy Finish</h5>
      <p>
        Thanks to celebrity trendsetters, glazed donut nails have become an
        iconic look. This nail trend features a sheer, milky base with a glossy,
        pearl-like shimmer on top. Ideal for everyday elegance or bridal glam,
        glazed nails are versatile, simple, and effortlessly stylish.
      </p>
    </div>
  );
};

export default GlazedDonut;
